<template>
  <div class="statusAndRole">
    <div class="status">
      <label>Статус</label>
      <span>Без статуса</span>
    </div>
    <div class="status">
      <label>Роль</label>
      <span
        v-if="roles"
        class="role"
        :style="{
          backgroundColor: roles[0].back_color,
          color: roles[0].text_color,
        }"
        >{{ roles !== '' ? roles[0].role_name : 'Не назначенно' }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusAndRole',
  props: ['roles'],
  components: {},
  data: () => ({}),
  methods: {},
}
</script>

<style lang="scss" scoped>
.statusAndRole {
  background-color: white;
  border: 1px solid #bedbeb;
  border-radius: 4px;
  display: grid;
  .status {
    padding: 30px;
    &:not(:last-of-type) {
      border-bottom: 1px solid #bedbeb;
    }
    label {
      font-size: 14px;
      line-height: 23px;
      color: #52525f;
      margin-bottom: 7px;
      width: 100%;
      display: block;
    }
    span {
      background-color: #52525f;
      border-radius: 4px;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      letter-spacing: 0.01em;
      color: #ffffff;
      padding: 8.5px 16px;
      display: block;
      width: max-content;
    }
  }
}
</style>
